import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSettingContext } from "context/SettingContext";
import usersAPI from "features/Setting/users/api/userApis";

const useDeleteUser = ({ sortBy, sortOrder }) => {
  const queryClient = useQueryClient();
  const { search } = useSettingContext();
  return useMutation({
    mutationFn: usersAPI.deleteUserInfo,
    onSuccess: (data) => {
      if (data?.data?.message === "User Profile Delete Successfully") {
        queryClient.removeQueries(["users-data", { sortBy, sortOrder, search }]);
        // queryClient.setQueryData(["users-data", { sortBy, sortOrder }], (oldQueryData) => {
        //   return {
        //     ...oldQueryData,
        //     data: {
        //       ...oldQueryData.data,
        //       message: data?.data?.message,
        //       User: oldQueryData.data.User.filter((user) => user._id !== data?.data?.user?._id),
        //     },
        //   };
        // });
      } else {
        console.error(data?.data?.message || "An unexpected error occurred");
      }
    },
    onError: (error) => {
      console.error("Delete User Error:", error?.response?.data?.message || error?.message);
    },
  });
};

export default useDeleteUser;
